<template>
<div class="login">
  <!-- <ModalAccount ref="ModalAccount" :account="listAccount" @action="selectAccount"></ModalAccount> -->
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-0">
          <v-card-text>
            <template v-if="store_slug && store_slug !== ''">
              <router-link :to="'/' + store_slug + '/'" class="text-deco">
                <div class="pb-4">
                  <v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
                </div>
              </router-link>
            </template>
            <template v-else>
              <router-link to="/" class="text-deco">
                <div class="pb-4">
                  <v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
                </div>
              </router-link>
            </template>
            <div class="pb-3 text-center text-subtitle-1 font-weight-bold black--text">
              Silahkan masuk ke Akun HWI Ecommerce Anda
            </div>
            <div class="text-subtitle-2 py-5">
              <span class="black--text">Belum punya akun?</span>
              <router-link :to="{ name: 'register' }">
                <span class="font-weight-bold pl-2">Daftar di sini</span>
              </router-link>
            </div>
            <v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text" dismissible> {{alerts.message}} </v-alert>
            <v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
              <div>
                <div class="text-subtitle-2 primary--text pb-1">Username atau Nomor Handphone</div>
                <v-text-field ref="inputUsername" color="primary" :rules="usernameRules" @focus="() => fieldErrors.username=''" :error-messages="fieldErrors.username" v-model="username" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense></v-text-field>
              </div>
              <div>
                <div class="text-subtitle-2 primary--text pb-1">Password</div>
                <v-text-field @click:append="showPassword" :type="passwordType" :rules="passwordRules" @focus="() => fieldErrors.password=''" :error-messages="fieldErrors.password" v-model="password" validate-on-blur single-line outlined class="color-primary rounded-lg password-field" height="40" dense :append-icon="passwordIcon" hide-details="auto"></v-text-field>
                <v-row>
                  <v-col cols="6" class="pt-1">
                    <v-checkbox label="Ingat saya" v-model="appTemp.isRemember" @change="updateSetting" class="small-check mt-0"></v-checkbox>
                  </v-col>
                  <v-col cols="6" class="pt-2 text-right text-body-2">
                    <router-link to="/ubah-password" class="text-deco grey--text text--darken-1">
                      <div>Lupa Password?</div>
                    </router-link>
                  </v-col>
                </v-row>
              </div>
              <div class="pt-5">
                <v-btn v-if="isAttempting" x-large depressed color="primary" class="col-12 rounded-lg">
                  <div class="subtitle-2">Sedang Diproses ...</div>
                </v-btn>
                <v-btn v-else x-large depressed color="primary" class="col-12 rounded-lg" type="submit">
                  <div class="subtitle-2">Masuk</div>
                </v-btn>

                <template v-if="store_slug !== ''">
                  <router-link :to="'/' + store_slug + '/'" class="d-block text-deco mt-3">
                    <v-btn text height="45" block color="primary" class="rounded-lg">
                      <div class="font-weight-bold text-body-2">Kembali ke Beranda</div>
                    </v-btn>
                  </router-link>
                </template>
                <template v-else>
                  <router-link :to="'/'" class="text-deco">
                    <v-btn text height="45" block color="primary" class="d-block rounded-lg mt-3">
                      <div class="font-weight-bold text-body-2">Kembali ke Beranda</div>
                    </v-btn>
                  </router-link>
                </template>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations
} from 'vuex'
// import ModalAccount from '@/views/store/login/ModalChooseAccount'

export default {
  components: {
    // ModalAccount
  },
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      passwordIcon: 'mdi-eye',
      usernameRules: [
        v => !!v || 'Username/No. Handphone tidak boleh kosong'
      ],
      passwordRules: [
        v => !!v || 'Password tidak boleh kosong',
      ],
      listAccount: [],
      store_slug: '',
      appTemp: {
        isRemember: false,
        lastLogin: null,
        expLogin: null,
        payload: null
      },
    }
  },
  computed: {
    ...mapState('auth', ['isAttempting', 'alerts', 'fieldErrors']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    ...mapMutations('auth', ['success', 'saveListAccount']),

    async validatePaste(val){
      let pasted = await val.clipboardData.getData('text')
      setTimeout(() => {
        if (!parseInt(pasted)) {
            this.username = ''
        }
      })
    },
    showPassword() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
        this.passwordIcon = 'mdi-eye-off'
      } else {
        this.passwordType = 'password'
        this.passwordIcon = 'mdi-eye'
      }
    },
    onLogin() {
      this.listAccount = []
      if (this.$refs.formLogin.validate()) {
        this.login({
          username: this.username,
          password: this.password
        }).then((data) => {
          if (Array.isArray(data)) {
            this.listAccount = data
            this.$refs.ModalAccount.modalShow()
          } else {
            this.selectAccount(data)
          }

          let appSetting = JSON.parse(localStorage.getItem('hwi-app-setting'))
          let credentials = this.generateKey({
            uname: this.username,
            pass: this.password
          })
          this.appTemp.payload = credentials
          appSetting.buyerApp = this.generateKey(this.appTemp)

          localStorage.setItem('hwi-app-setting', JSON.stringify(appSetting))
        });
      }
    },
    selectAccount(data) {
      if (this.listAccount.length > 0) {
        this.saveListAccount(this.listAccount)
      }
      this.success(data)
      const {
        redirect
      } = this.$route.query;

      if (redirect) {
        this.$router.push(redirect);
      } else {
        if (this.store_slug == '') {
          this.$router.push({
            name: "home"
          })
        } else {
          this.$router.push('/' + this.store_slug)
        }
      }
    },
    updateSetting() {
      if (this.username == '') {
        setTimeout(() => {
          this.$refs.inputUsername.focus()
        }, 200)
      }
    },
    generateKey(dataset) {
      if (dataset) {
        const datakey = JSON.stringify(dataset)
        return window.btoa(datakey)
      }
    },
    decryptKey(key) {
      if (key) {
        const datakey = window.atob(key)
        return JSON.parse(datakey)
      }
    }
  },
  created() {
    this.$store.dispatch('setPageTitle', 'Masuk');
    const store = localStorage.getItem('HwiEcomStore')
    this.store_slug = ((store !== undefined)) ? store : ''
    
    const appSetting = JSON.parse(localStorage.getItem('hwi-app-setting'))
    if (appSetting && appSetting !== undefined) {
      if (appSetting.buyerApp !== undefined) {
        const dataset = this.decryptKey(appSetting.buyerApp)
        // console.log('dataset', dataset)
        if (Object.keys(dataset).length > 0) {
          this.appTemp = {
            isRemember: dataset.isRemember,
            lastLogin: null,
            expLogin: null,
            payload: dataset.payload
          }

          if (dataset.isRemember) {
            const credentials = this.decryptKey(dataset.payload)
            this.username = credentials.uname
            this.password = credentials.pass
          } else {
            setTimeout(() => {
              this.$refs.inputUsername.focus()
            }, 200)
          }
        }
      }
    } else {
      const datasource = {
        buyerApp: null,
        storeApp: null
      }
      localStorage.setItem('hwi-app-setting', JSON.stringify(datasource))
    }
  }
};
</script>
